module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ot-select-brand-mark.486ae708.svg";